import {request} from '@/utils/http';

let userLogin = '/fronted/member/login';
let userPeople = '/fronted/address/updateContactInfo'
let getUserAddress = '/fronted/address/info'
let resetpwd = '/fronted/member/update/password'
let userAvatar = '/fronted/member/update/avatar'
let userRegister = '/fronted/company/register'
let userDetail = '/fronted/member/refresh'

export function POST_USERLOGIN(params){
  return request(userLogin,'post',params)
}

export function POST_USERPEOPLE(params){
  return request(userPeople,'post',params)
}
export function GET_USERADDRESS(params){
  return request(getUserAddress,'get',params)
}
export function POST_RESETPWD(params){

  return request(resetpwd,'post',params)
}
export function POST_USERAVATAR(params){
  return request(userAvatar,'post',params)
}
export function POST_USERREGISTER(params){
  return request(userRegister,'post',params)
}
export function GET_USERDETAIL(params){
  return request(userDetail,'get',params,{},'','',true)
}


// WEBPACK FOOTER //
// ./src/api/user.api.js